export default {
  institutionName: '莘昕书堂',
  systemName: '晚托管理系统',
  logoUrl: '/logo.png',
  browserTitle: '莘昕书堂晚托管理系统',
  copyrightYear: '2024',
  navigation: [
    { path: '/dashboard', name: 'Dashboard', label: '工作台', icon: 'el-icon-s-home', permission: 'dashboard:read' },
    { path: '/students', name: 'Students', label: '学生管理', icon: 'el-icon-user-solid', permission: 'student:read' },
    { path: '/classes', name: 'Classes', label: '班级管理', icon: 'el-icon-school', permission: 'student:read' },
    { path: '/attendance', name: 'Attendance', label: '考勤记录', icon: 'el-icon-date', permission: 'attendance:read' },
    { path: '/leaves', name: 'Leaves', label: '请假审批', icon: 'el-icon-document-checked', permission: 'leave:audit' },
    { path: '/feedbacks', name: 'Feedbacks', label: '作业反馈', icon: 'el-icon-edit-outline', permission: 'feedback:write' },
    { path: '/notices', name: 'Notices', label: '通知公告', icon: 'el-icon-bell', permission: 'notice:read' },
    { path: '/payments', name: 'Payments', label: '收费管理', icon: 'el-icon-money', permission: 'payment:write', enabled: false },
    { path: '/users', name: 'Users', label: '员工管理', icon: 'el-icon-s-custom', permission: 'user:write' },
    { path: '/operation-logs', name: 'OperationLogs', label: '操作日志', icon: 'el-icon-document', permission: 'user:write' }
  ]
}
